<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("partsmente.title") }}</h1>
    <b-tabs content-class="mt-3">
      <b-tab :title="this.$i18n.t('partsmente.tab_search')" active>
        <b-card class="w-50 mb-3">
          <form>
            <b-form-group
              id="serialSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('partsmente.label_serial')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="serialSearch" :placeholder="this.$i18n.t('partsmente.placeholder_serial')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="codeSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('partsmente.label_code')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="codeSearch" :placeholder="this.$i18n.t('partsmente.placeholder_code')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="kindSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('partsmente.label_kind')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="kindSearch" :placeholder="this.$i18n.t('partsmente.placeholder_kind')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="makerSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('partsmente.label_maker')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="makerSearch" :placeholder="this.$i18n.t('partsmente.placeholder_maker')"></b-form-input>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("partsmente.button_search") }}</b-button>
            </div>
          </form>
        </b-card>
        <b-card v-if="isSearch">
        <b-row class="d-flex align-items-center">
          <b-col sm="2" md="2" class="my-1">
            <b-dropdown right variant="primary" :text=lblAction>
              <b-dropdown-item @click="valid" >{{ $i18n.t("partsmente.button_valid") }}</b-dropdown-item>
              <b-dropdown-item @click="invalid" >{{ $i18n.t("partsmente.button_invalid") }}</b-dropdown-item>
            </b-dropdown>
          </b-col>
          <b-col sm="2" md="2" class="my-1">
            <div>{{ $i18n.t("partsmente.label_num_of_disp") }}
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
                style="width: auto"
              ></b-form-select>
            </div>
          </b-col>
            <b-col sm="8" md="8" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :per-page="perPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="items"
            :fields="fields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
            :tbody-tr-class="rowClass"
          >
            <template v-slot:head(action)="row">
              <b-form inline>
                <b-form-checkbox size="lg" :checked="isAllSelected" v-on:change="selectAll" name="check-button"></b-form-checkbox>
              </b-form>
            </template>
            <template v-slot:cell(action)="row">
              <b-form-checkbox size="lg" v-model="row.item.selectedFlg" v-on:change="selectOne(row.item.index)"  name="check-button"></b-form-checkbox>
            </template>
            <template v-slot:cell(edit)="row">
              <b-button v-if="row.item.efFlg === '1'" size="sm" class="mr-2" @click="edit(row.item, row.index, $event.target)">{{ $i18n.t("partsmente.button_edit") }}</b-button>
              <b-button v-if="row.item.efFlg === '0'" disabled=true size="sm" class="mr-2" @click="edit(row.item, row.index, $event.target)">{{ $i18n.t("partsmente.button_edit") }}</b-button>
            </template>
          </b-table>
        </b-card>
      </b-tab>
      <b-tab :title="this.$i18n.t('partsmente.tab_register')">
        <b-card class="w-50">
          <form>
            <b-form-group
              id="serialForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('partsmente.label_serial_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="serialForm" :placeholder="this.$i18n.t('partsmente.placeholder_serial')" maxlength="40"></b-form-input>
            </b-form-group>
            <b-form-group
              id="codeForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('partsmente.label_code_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="codeForm" :placeholder="this.$i18n.t('partsmente.placeholder_code')" maxlength="40"></b-form-input>
            </b-form-group>
            <b-form-group
              id="kindForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('partsmente.label_kind')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="kindForm" :placeholder="this.$i18n.t('partsmente.placeholder_kind')" maxlength="40"></b-form-input>
            </b-form-group>
            <b-form-group
              id="makerForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('partsmente.label_maker')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="makerForm" :placeholder="this.$i18n.t('partsmente.placeholder_maker')" maxlength="60"></b-form-input>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("partsmente.button_register") }}</b-button>
            </div>
          </form>
        </b-card>
      </b-tab>
    </b-tabs>
    <confirmModal modId="md-confirm" :msg="this.$i18n.t('partsmente.info_register')" :titleMsg="this.$i18n.t('partsmente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirmModal modId="md-confirm2" :msg="this.$i18n.t('partsmente.info_valid')" :titleMsg="this.$i18n.t('partsmente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="validConfirm"/>
    <confirmModal modId="md-confirm3" :msg="this.$i18n.t('partsmente.info_invalid')" :titleMsg="this.$i18n.t('partsmente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="invalidConfirm"/>
    <confirmModal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  created () {
    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var body = {}
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/common/checkLogin', body, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        }
      })
      .catch(res => {
        // とりあえずログイン画面へ飛ばす
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        this.$router.push('/')
      })
  },
  data () {
    return {
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      fields: [
        { key: 'action', label: '' },
        { key: 'serial', label: this.$i18n.t('partsmente.label_serial'), sortable: true },
        { key: 'code', label: this.$i18n.t('partsmente.label_code'), sortable: true },
        { key: 'kind', label: this.$i18n.t('partsmente.label_kind'), sortable: true },
        { key: 'maker', label: this.$i18n.t('partsmente.label_maker'), sortable: true },
        { key: 'uOp', label: this.$i18n.t('partsmente.label_register_user'), sortable: true },
        { key: 'uDate', label: this.$i18n.t('partsmente.label_register_date'), sortable: true },
        { key: 'efFlgStr', label: this.$i18n.t('partsmente.label_ef_flg'), sortable: true },
        { key: 'edit', label: this.$i18n.t('partsmente.button_edit') }
      ],
      items: [
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      isAllSelected: false,
      selectedSerials: [],
      lblAction: this.$i18n.t('partsmente.button_action'),
      serialForm: null,
      codeForm: null,
      kindForm: null,
      makerForm: null,
      errMsg: null,
      errSbj: null
    }
  },
  methods: {
    search: function () {
      // リクエスト
      var reqObj = {}
      var serialStr = this.serialSearch
      if (serialStr == null) {
        serialStr = ''
      }
      var codeStr = this.codeSearch
      if (codeStr == null) {
        codeStr = ''
      }
      var kindStr = this.kindSearch
      if (kindStr == null) {
        kindStr = ''
      }
      var makerStr = this.makerSearch
      if (makerStr == null) {
        makerStr = ''
      }

      reqObj.serial = serialStr
      reqObj.serialLikeFlg = '1'
      reqObj.code = codeStr
      reqObj.kind = kindStr
      reqObj.maker = makerStr
      reqObj.efFlg = ''

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/parts/select', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var partsList = res.data.partsInfo
            var partss = []
            if (partsList.length === 0) {
              this.errSbj = this.$i18n.t('partsmente.title')
              this.errMsg = this.$i18n.t('partsmente.err_not_data')
              this.$bvModal.show('md-err')
              this.isSearch = false
              return
            }

            // 整形
            for (var i = 0; i < partsList.length; i++) {
              var parts = {}
              // utc -> local 変換
              // momentオブジェクト(UTC)に変換
              var utc = this.$moment.utc(partsList[i].u_date, 'YYYY-MM-DD HH:mm:ss')
              var output = null
              if (String(utc) === 'Invalid date') {
                output = ''
              } else {
                // local時刻に変換＆フォーマット
                output = utc.local().format('YYYY-MM-DD HH:mm:ss')
              }
              parts.serial = partsList[i].serial
              parts.code = partsList[i].code
              parts.kind = partsList[i].kind
              parts.maker = partsList[i].maker
              parts.uOp = partsList[i].u_op_name
              parts.uDate = output
              // TODO json
              parts.edit = this.$i18n.t('partsmente.label_edit')
              parts.efFlg = partsList[i].ef_flg
              if (partsList[i].ef_flg === '1') {
                // TODO json
                parts.efFlgStr = this.$i18n.t('partsmente.label_valid')
              } else {
                // TODO json
                parts.efFlgStr = this.$i18n.t('partsmente.label_invalid')
                parts.status = 'awesome'
              }
              parts.selectedFlg = false
              // 選択状態書き換え時に使用するindex
              parts.index = i
              partss.push(parts)
            }
            // ページング設定
            this.totalRows = partss.length
            // 一旦データクリア
            this.items.splice(0)
            // データセット
            this.items.splice(0, 0, ...partss)
            // 検索結果表示
            this.isSearch = true
            // 全選択チェック
            this.isAllSelected = false
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    regist: function () {
      // 入力値チェック
      if (this.serialForm === null || this.serialForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_serial_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.serialForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_serial_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkAlphaNumSymbol(this.serialForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_serial_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (this.codeForm === null || this.codeForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_code_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.codeForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_code_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkAlphaNumSymbol(this.codeForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_code_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.kindForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_kind_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.makerForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_maker_symbol')
        this.$bvModal.show('md-err')
        return
      }

      // 空文字にして登録(「null」文字列が登録されることを避ける)
      if (this.kindForm == null) {
        this.kindForm = ''
      }
      if (this.makerForm == null) {
        this.makerForm = ''
      }

      // リクエスト
      var reqObj = {}
      reqObj.serial = this.serialForm
      reqObj.code = this.codeForm
      reqObj.kind = this.kindForm
      reqObj.maker = this.makerForm

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/parts/register', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    registConfirm: function () {
      this.serialForm = null
      this.codeForm = null
      this.kindForm = null
      this.makerForm = null
      this.$bvModal.hide('md-confirm')
    },
    valid: function () {
      this.selectedSerials.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          this.selectedSerials.push(this.items[i].serial)
        }
      }

      if (this.selectedSerials.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.mode = '1'
      reqObj.serial = this.selectedSerials

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/parts/updateEfFlg', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.search()
            this.$bvModal.show('md-confirm2')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    invalid: function () {
      this.selectedSerials.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          this.selectedSerials.push(this.items[i].serial)
        }
      }

      if (this.selectedSerials.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.mode = '0'
      reqObj.serial = this.selectedSerials

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/parts/updateEfFlg', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.search()
            this.$bvModal.show('md-confirm3')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    validConfirm: function () {
      this.$bvModal.hide('md-confirm2')
    },
    invalidConfirm: function () {
      this.$bvModal.hide('md-confirm3')
    },
    edit: function (item, index, button) {
      this.$store.store.state.serial = item.serial
      this.$store.store.state.code = item.code
      this.$store.store.state.kind = item.kind
      this.$store.store.state.maker = item.maker
      this.$router.push({ path: 'partsmenteEdit' })
    },
    rowClass: function (item, type) {
      if (!item) return
      if (item.status === 'awesome') return 'table-danger'
    },
    selectAll () {
      if (this.isAllSelected) {
        this.isAllSelected = false
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].selectedFlg = false
        }
      } else {
        this.isAllSelected = true
        for (var j = 0; j < this.items.length; j++) {
          this.items[j].selectedFlg = true
        }
      }
    },
    selectOne (index) {
      this.items[index].selectedFlg = !this.items[index].selectedFlg
      var selectedCnt = 0
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          selectedCnt++
        }
      }
      if (selectedCnt !== this.items.length) {
        this.isAllSelected = false
      } else {
        this.isAllSelected = true
      }
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Partsmente.vue